import React, { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'

const AboutSiteNavContext = createContext()
const AboutSiteToggleNavContext = createContext()

/**
 * The about site nav custom hook.
 */
export const useAboutSiteNav = () => useContext(AboutSiteNavContext)

/**
 * The about site toggle nav custom hook.
 */
export const useAboutSiteToggleNav = () => useContext(AboutSiteToggleNavContext)

/**
 * The AboutSiteNavProvider's component.
 */
export const AboutSiteNavProvider = props => {
  const { children } = props
  const [navToggle, setNavToggle] = useState(false)
  const handleToggleNav = () => setNavToggle(prevNavToggle => !prevNavToggle)

  return (
    <AboutSiteNavContext.Provider value={navToggle}>
      <AboutSiteToggleNavContext.Provider value={handleToggleNav}>{children}</AboutSiteToggleNavContext.Provider>
    </AboutSiteNavContext.Provider>
  )
}

AboutSiteNavProvider.propTypes = {
  children: PropTypes.node.isRequired
}
